/**
 * The left menu of Teslyn Field and Teslyn Cloud (MB's R10, 24 Oct 2026), as Supabase's sidebar: expanded (icons
 * and words), icons only, or hidden for the most room. Each person's choice is kept per app; signed out, Teslyn
 * Field keeps one choice for the laptop.
 */
export type MenuMode = 'expanded' | 'icons' | 'hidden';

export const MENU_MODES: readonly { readonly value: MenuMode; readonly label: string }[] = [
  // "Pinned" (MB, 25 Oct 2026); the stored value stays 'expanded' so choices already made are kept
  { value: 'expanded', label: 'Pinned' },
  { value: 'icons', label: 'Icons only' },
  { value: 'hidden', label: 'Hidden' },
];

/** The menu until a person chooses, in both apps: icons only (MB, 25 Oct 2026). */
export const DEFAULT_MENU_MODE: MenuMode = 'icons';

/** The storage key of a person's menu choice in one app. */
export function menuModeKey(app: 'field' | 'cloud', personId: string | null): string {
  return `teslyn.${app}.menu.v1.${personId ?? 'signed-out'}`;
}

/** A stored choice, or the default for anything that is not one. */
export function parseMenuMode(v: unknown): MenuMode {
  return v === 'expanded' || v === 'icons' || v === 'hidden' ? v : DEFAULT_MENU_MODE;
}

/**
 * Icons only opens to show the names while the mouse is on it, after this pause, so passing over it on the way to
 * the page does not open it (MB, 25 Oct 2026).
 */
export const MENU_OPEN_DELAY_MS = 150;

/**
 * The opened menu (icons only, or hidden opened from its button) closes this long after the mouse leaves it, so a
 * slip of the mouse past its edge does not close it.
 */
export const MENU_CLOSE_DELAY_MS = 300;
